module.exports = __webpack_public_path__ + "static/media/icon-todo-in-person.00e8eb1f.svg";